/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Stat_PeopleInputs */

const cs_settings_venues_stat_people = /** @type {(inputs: Settings_Venues_Stat_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidé`)
};

const en_settings_venues_stat_people = /** @type {(inputs: Settings_Venues_Stat_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

/**
* | output |
* | --- |
* | "People" |
*
* @param {Settings_Venues_Stat_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_stat_people = /** @type {((inputs?: Settings_Venues_Stat_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Stat_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_stat_people(inputs)
	return cs_settings_venues_stat_people(inputs)
});